<template>
	<div class="Footer-list">
		<slot name="heading"></slot>
		<ul>
			<slot name="links"></slot>
		</ul>
	</div>
</template>

<script>
export default {
	name: 'CloFooterList',
};
</script>

<style lang="scss">
.Footer-list {
	ul {
		list-style: none;
		margin: 0;
		line-height: 1.2;
	}
	a {
		@include interactiveColor(color, $color-white, $color-white);
		text-underline-offset: $space-rel-xs;
		text-decoration-line: underline;
		text-decoration-style: solid;
		text-decoration-thickness: 0.0625rem;
		@include interactiveColor(text-decoration-color, transparent, $color-text-reverse);
	}
}
</style>
